import rawRules from './abilities.rules.json';

/**
 * Frontend abilities rule table — React/zustand bağımsız.
 *
 * Veri kaynağı: `abilities.rules.json` (single source of truth).
 *   - apps/web-admin/src/lib/abilities.tsx (React tarafı) buradan okur
 *   - apps/api/src/core/abilities/abilities-parity.spec.ts (backend test)
 *     JSON'u doğrudan fs ile okuyup backend CASL factory ile parite kontrol eder
 *
 * Backend ↔ Frontend drift için parity test CI'da fail eder.
 */

export type Action = 'create' | 'read' | 'update' | 'delete' | 'approve' | 'export';

export type Subject =
  | 'Card'
  | 'CardStock'
  | 'Transaction'
  | 'Receipt'
  | 'Reimbursement'
  | 'Approval'
  | 'ApprovalPolicy'
  | 'Budget'
  | 'Employee'
  | 'OrgHierarchy'
  | 'Department'
  | 'Company'
  | 'Billing'
  | 'Report'
  | 'Alarm'
  | 'AdminConsole'
  /// ADR-051 P2b — Sipay Digital KYC (Sodec) cardholder-self. Mobil akış; web-admin UI'da
  /// kullanılmaz ama BE↔FE parity için rule tablosunda mevcut (parity spec drift'i engeller).
  | 'SipayKyc'
  /// ADR-051 P3 (T3.1) — Sipay cüzdan fonlaması (B2P allowance). Finans/yönetici rolleri
  /// çalışan cüzdanını fonlar; BE↔FE parity için rule tablosunda mevcut.
  | 'Wallet'
  /// DM kapsam planı (2026-07-23) — firma HAZİNE cüzdanı (/wallets/me: bakiye + IBAN).
  /// `Wallet`'tan ayrıldı; DEPARTMENT_MANAGER'da YOK (roster görür, hazineyi görmez).
  | 'FirmWallet';

export type Role =
  | 'OWNER'
  | 'CEO'
  | 'CFO'
  | 'ACCOUNTANT'
  | 'DEPARTMENT_MANAGER'
  | 'TEAM_LEAD'
  | 'EMPLOYEE'
  | 'EXPENSE_ONLY';

export interface AbilityRule {
  role: Role;
  action: Action | '*';
  subject: Subject | '*';
}

export const RULES = rawRules as AbilityRule[];

/**
 * Pure ability check — UI gating için.
 */
export function canByRole(role: Role | null, action: Action, subject: Subject): boolean {
  if (!role) return false;
  return RULES.some(
    (r) => r.role === role && (r.action === '*' || r.action === action) && (r.subject === '*' || r.subject === subject),
  );
}
